import InfoIcon from '@/assets/icons/icon-info.svg'
import EmptyIcon from '@/assets/images/not-found.svg'
import { Skeleton } from '@/components/ui/skeleton.tsx'
import { Tooltip } from '@/components/ui/tooltip'

interface Props {
  isFetching: boolean
  value: number | undefined
}

export const CustomerLifetimeValue = ({ isFetching, value }: Props) => {
  return (
    <div className="flex flex-col gap-2 rounded-lg bg-[#fff] p-8 pb-4 pt-4 text-secondary-500 shadow-sm dark:bg-[#272A39] dark:text-white xl:gap-4">
      {isFetching ? (
        <Skeleton className="h-6 w-6" />
      ) : !isFetching && (value === undefined || isNaN(value)) ? (
        <EmptyIcon className="h-6 w-6" />
      ) : (
        <p className="text-2xl font-semibold leading-none">
          ${value?.toFixed(2)}
        </p>
      )}

      <p className="flex max-w-fit items-center gap-1 text-text-sub">
        Customer Lifetime Value (CLV)
        <Tooltip
          content={
            <p className="max-w-[200px] text-text-sub">
              The Customer Lifetime Value will be calculated by the Revenue of
              the set timeframe divided by the average subscriber count during
              the set timeframe which equals the CLV (Customer Lifetime Value)
            </p>
          }
        >
          <InfoIcon className="h-4 w-4 cursor-pointer hover:text-black dark:hover:text-white" />
        </Tooltip>
      </p>
    </div>
  )
}
